module.exports = __webpack_public_path__ + "static/media/Andrea Alstad Headshot.ae67ef26.png";